/* eslint-disable */
/* this file is generated by generateIcons script */

import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class CloudConfigIcon extends BaseIcon {
  getChildren = () => [
    <path fill={ this.getColor() }
          d="M60.5,33.5a6.28,6.28,0,0,0,.5-3A19.76,19.76,0,0,0,42,10H41.5C33,10,25,16,23,24a21.42,21.42,0,0,0-5.5-1A18.26,18.26,0,0,0,0,41.5C0,51.5,7.5,60,17.5,60H57c7.5,0,13-6,13-13.5C70,40.5,66.5,35,60.5,33.5ZM32,37a1,1,0,0,1-1,1H30V49a1,1,0,0,1-2,0V38H27a1,1,0,0,1-1-1V35a1,1,0,0,1,1-1h1V31a1,1,0,0,1,2,0v3h1a1,1,0,0,1,1,1Zm8,9a1,1,0,0,1-1,1H38v2a1,1,0,0,1-2,0V47H35a1,1,0,0,1-1-1V44a1,1,0,0,1,1-1h1V31a1,1,0,0,1,2,0V43h1a1,1,0,0,1,1,1Zm8-6a1,1,0,0,1-1,1H46v8a1,1,0,0,1-2,0V41H43a1,1,0,0,1-1-1V38a1,1,0,0,1,1-1h1V31a1,1,0,0,1,2,0v6h1a1,1,0,0,1,1,1Z"/>
  ]
  getViewBox = () => '0 0 70 70'
}
